import Document from '@sunbit-dev/ui/src/components/ui/document/Document';
import qs from 'qs';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadStaticDocumentThunk } from '../actions/documentActions';
import { selectDocumentContent, selectLocationSearch } from '../selectors';

const ApprovalTermsContainer:React.FC = () => {
  const locationSearch = useSelector(selectLocationSearch);
  const documentContent = useSelector(selectDocumentContent);
  const dispatch = useDispatch();
  const params = qs.parse(locationSearch, { ignoreQueryPrefix: true }) as {documentType: string};

  const loadDocument = React.useCallback(() => {
    dispatch(loadStaticDocumentThunk(params.documentType));
  }, [dispatch, params]);

  return <Document loadDocument={loadDocument} content={documentContent} />;
}

export default ApprovalTermsContainer;
